import React, { useState } from 'react';
import { useBrand } from '../../../app/config/brand';
import { FormData } from '../../../shared/data/formData';
import { Button } from '../../../shared/components/ui/Button';
import { Input } from '../../../shared/components/ui/Input';
import { Select } from '../../../shared/components/ui/Select';
import { Card } from '../../../shared/components/ui/Card';
import { PageTitle } from '../../../shared/components/ui/PageTitle';
import { SectionTitle } from '../../../shared/components/ui/SectionTitle';

const CustomerProfile: React.FC = () => {
  const brand = useBrand();
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', label: 'Manage Profile' },
    { id: 'firm', label: 'Manage Firm' },
    { id: 'contacts', label: 'Firm Contacts' },
    { id: 'locations', label: 'Firm Locations' },
    { id: 'efile', label: 'eFile Registration' },
    { id: 'billing', label: 'Billing Center' },
  ];

  return (
    <div>
      <PageTitle>Manage Profile</PageTitle>

      <div className="flex border-b mb-6" style={{ borderColor: brand.colors.border }}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className="px-5 py-3 text-sm font-medium border-b-2 -mb-px transition-colors"
            style={{
              borderColor: activeTab === tab.id ? brand.colors.primary : 'transparent',
              color: activeTab === tab.id ? brand.colors.link : brand.colors.textLight,
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'profile' && (
        <Card>
          <div className="flex justify-between items-center mb-6">
            <SectionTitle>Edit Profile</SectionTitle>
            <a href="#" className="text-sm font-medium" style={{ color: brand.colors.link }}>Change Password</a>
          </div>

          <div className="grid grid-cols-3 gap-4 mb-4">
            <Input label="First Name" required defaultValue={brand.user.firstName} />
            <Input label="Middle Name" />
            <Input label="Last Name" required defaultValue={brand.user.lastName} />
          </div>

          <div className="grid grid-cols-3 gap-4 mb-4">
            <Input label="Phone" required defaultValue={brand.user.phone} />
            <Input label="Extension" />
            <Input label="Fax" />
          </div>

          <Input label="Email Address" required defaultValue={brand.user.email} className="mb-4" />

          <div className="grid grid-cols-2 gap-4 mb-6">
            <Select label="Firm Location" required options={FormData.firmLocations} />
            <Select label="Contact Type" required options={FormData.contactTypes} />
          </div>

          <p className="text-sm mb-6" style={{ color: brand.colors.textLight }}>
            The information provided here will be used to enable access to the platform, fulfill transactions, and communicate about orders. To learn more, review our <a href="/legal/privacy" target="_blank" rel="noopener noreferrer" style={{ color: brand.colors.link }}>Privacy Policy</a>.
          </p>

          <Button>UPDATE</Button>
        </Card>
      )}
    </div>
  );
};

export default CustomerProfile;
